module.exports = __webpack_public_path__ + "static/img/icon_zanwusyjl@2x.9a365529.png";